import React from 'react';
import { useModalClose } from '../../../../utils/useModalClose';
import { CleanDeliveryOrder } from '../../../../export-types/cleaned-types';
import { InputWrapper } from '../../../common/input-wrapper';
import { DeliveryOrderService } from '../../../../services/delivery-order.service';
import { AlertService } from '../../../../services/alert.service';
import useSWR from 'swr';
import { fetcher } from '../../../../services/api';
import { ModalsService } from '../../../../services/modals.service';
import { SentToRecipientConfirmationModal } from './sent-to-recipient-confirmation-modal';

type Props = {
  close: () => void;
  reject: () => void;
  orderId: string;
  readOnly?: boolean;
};

export const SentToRecipientModal: React.FC<Props> = ({
  orderId,
  close,
  reject,
  readOnly,
}) => {
  const { data: order, mutate } = useSWR<CleanDeliveryOrder>(
    `/delivery-order/${orderId}`,
    fetcher,
  );

  const address = order?.address;

  const modalRef = useModalClose(reject);
  return (
    <div className="modal-dialog" ref={modalRef}>
      <div className="modal-content">
        <div className="modal-body">
          <div className="d-flex flex-row justify-content-between align-items-center">
            <h3>Данные получателя</h3>
            <div className="btn p-0" onClick={reject}>
              <i className="bi bi-x fs-36 color-gray-600" />
            </div>
          </div>
          <div className={'d-flex flex-column gap-2'}>
            <InputWrapper title="Имя" className="col">
              <input
                className="form-control"
                type="string"
                value={address?.name}
                readOnly={true}
              />
            </InputWrapper>

            <InputWrapper title="Город" className="col">
              <input
                className="form-control"
                type="string"
                value={address?.city}
                readOnly={true}
              />
            </InputWrapper>
            {address?.passport && (
              <InputWrapper title="Паспорт" className="col">
                <input
                  className="form-control"
                  type="string"
                  value={address.passport}
                  readOnly={true}
                />
              </InputWrapper>
            )}
            {address?.fullAddress && (
              <InputWrapper title="Адрес" className="col">
                <input
                  className="form-control"
                  type="string"
                  value={address.fullAddress}
                  readOnly={true}
                />
              </InputWrapper>
            )}

            {address?.phone && (
              <InputWrapper title="Телефон" className="col">
                <input
                  className="form-control"
                  type="string"
                  value={address.phone}
                  readOnly={true}
                />
              </InputWrapper>
            )}

            {address?.companyName && (
              <InputWrapper title="Наименование компании" className="col">
                <input
                  className="form-control"
                  type="string"
                  value={address.companyName || '-'}
                  readOnly={true}
                />
              </InputWrapper>
            )}

            {address?.companyInn && (
              <InputWrapper title="ИНН" className="col">
                <input
                  className="form-control"
                  type="string"
                  value={address.companyInn || '-'}
                  readOnly={true}
                />
              </InputWrapper>
            )}
          </div>
        </div>
        {!readOnly && order && (
          <div className="modal-footer justify-content-end">
            <button
              type="button"
              className="btn btn-success w-100"
              onClick={async () => {
                close();
                await ModalsService.createModal(
                  SentToRecipientConfirmationModal,
                  {
                    onConfirm: async () => {
                      await DeliveryOrderService.updateDeliveryOrder(
                        { status: 'sentToRecipient' },
                        order.id,
                      )
                        .then(() => {
                          AlertService.success();
                        })
                        .then(() => mutate());
                    },
                  },
                );
              }}
            >
              Выдача посылки
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
